import React from 'react';
import Experiments from '@wix/wix-experiments';
import { ExperimentsProvider as WixExperimentsProvider } from '@wix/wix-experiments-react';

export interface IExperimentsWrapperProps {
  experiments: Experiments;
  children: React.ReactNode;
}

// NOTE: consider removing this provider and always use experiments from redux
export class ExperimentsProvider extends React.Component<IExperimentsWrapperProps> {
  public render() {
    return (
      <WixExperimentsProvider options={{ experiments: this.props.experiments.all() }}>
        {this.props.children}
      </WixExperimentsProvider>
    );
  }
}
